import { render, staticRenderFns } from "./OneClickButton.vue?vue&type=template&id=fd909554&"
import script from "./OneClickButton.vue?vue&type=script&lang=js&"
export * from "./OneClickButton.vue?vue&type=script&lang=js&"
import style0 from "./OneClickButton.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports